// extracted by mini-css-extract-plugin
module.exports = {"headingXl":"utils_headingXl__3PLyJ","lightText":"utils_lightText__LNqnZ"};